export default __webpack_public_path__ + "static/media/tpnllogo.d8a4dace.png";